import { theme } from '@/theme/theme';
import { Box, TableCell, Typography, styled } from '@mui/material';

export const Container = styled(Box)`
  width: 100%;
  max-width: 400px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  font-family: sans-serif;
  font-size: 14px;
`;

export const Header = styled(Box)`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
`;

export const BackText = styled(Typography)`
  font-size: 14px;
  margin-left: 8px;
`;

export const TitleContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
`;

export const BlockTitle = styled(Typography)`
  font-size: 20px;
  font-weight: 500;
  width: 100%;
`;

export const SubtitleSpan = styled('span')`
  font-weight: 400;
  font-size: 14px;
  color: ${theme.palette.primary.light};
  margin-left: 2%;
`;

export const SectionContainer = styled(Box)`
  padding: 8px 16px;
  width: 100%;
`;

export const SectionTitle = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const StyledTableCellLabel = styled(TableCell)`
  font-size: 12px;
  font-weight: 400;
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
  width: 100%;
  margin-left: auto;
`;

export const StyledTableCellValue = styled(TableCell)`
  font-size: 12px;
  font-weight: bold;
  padding: 8px 16px;
  border-bottom: 1px solid #e0e0e0;
  width: 100%;
  margin-left: auto;
`;

export const StatusIndicator = styled('div')`
  width: 8px;
  height: 16px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
`;

export const ImagesContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ImageWrapper = styled(Box)`
  position: relative;
`;

export const Image = styled('img')`
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
`;

export const ImageLabel = styled(Box)`
  position: absolute;
  bottom: 8px;
  right: 8px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
`;
